<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon icon-tabler icon-tabler-mail-check"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path
      d="M11 19h-6a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v6"
    ></path>
    <path d="M3 7l9 6l9 -6"></path>
    <path d="M15 19l2 2l4 -4"></path>
  </svg>
</template>

<script lang="ts" setup>
export type IconProps = {
  width?: string;
  height?: string;
};

withDefaults(defineProps<IconProps>(), {
  width: "24px",
  height: "24px",
});
</script>
